import React from 'react';
import SelectFieldCheckbox from './SelectFieldCheckbox';
import LeadService from '../../../../Services/leadService';
import ErrorMessage from '../../../ErrorMessage';

export default class LeadSelect extends React.Component {
  static defaultProps = {
    value: null,
    className: 'w-100 form-control form-control-sm',
    filterCleared: false,
    fieldName: 'defaultFieldname',
    onChange: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      selectValues: [],
    };
  }

  componentDidMount() {
    this.populateListData();
  }

  populateListData() {
    LeadService.GetLeadList()
      .then((result) => {
        const optValues = [{ label: 'Choose one...', value: '', disabled: false }];
        result.forEach((lead) => {
          optValues.push({
            label: lead.companyName,
            value: lead.leadId,
            disabled: false,
          });
        });

        this.setState({ selectValues: optValues });
      })
      .catch(() => {
        this.setState({ selectValues: [] });
        ErrorMessage.SetErrorMessage('LES43');
      });
  }

  render() {
    return (
      <SelectFieldCheckbox
        value={this.props.value}
        className={this.props.className}
        fieldName={this.props.fieldName}
        onChange={this.props.onChange}
        filterCleared={this.props.filterCleared}
        selectValues={this.state.selectValues}
      />
    );
  }
}
